var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('Head'),(!_vm.isPhone)?_c('scenePc'):_vm._e(),(_vm.isPhone)?_c('sceneMobile'):_vm._e(),_c('Foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }